import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpEvaluationResultFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpEvaluationResult
 */

export class ExpEvaluationResultFactory {}
_ExpEvaluationResultFactory = ExpEvaluationResultFactory;
_defineProperty(ExpEvaluationResultFactory, "FromJSON", function (json) {
  return _ExpEvaluationResultFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpEvaluationResultFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'nodeID': json['nodeID'],
    'result': json['result']
  };
});
_defineProperty(ExpEvaluationResultFactory, "ToJSON", function (value) {
  return _ExpEvaluationResultFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpEvaluationResultFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'nodeID': value.nodeID,
    'result': value.result
  };
});
//# sourceMappingURL=ExpEvaluationResult.js.map
